module.exports = __webpack_public_path__ + "static/How-to-manage-tabs-31-e1403553018931-4b2e5a8c12158c88e341cd25bb227f1b.jpg";